/** 生产环境默认 /api（Nginx 反代）；开发环境默认直连后端 3006 */
export function getApiBaseUrl() {
  if (process.env.REACT_APP_API_BASE_URL) {
    return process.env.REACT_APP_API_BASE_URL.replace(/\/$/, '');
  }
  return process.env.NODE_ENV === 'production' ? '/api' : 'http://localhost:3006/api';
}

export function getFileBaseUrl() {
  const apiBase = getApiBaseUrl();
  if (/^https?:\/\//i.test(apiBase)) {
    return apiBase.replace(/\/api$/, '');
  }
  return '';
}
